import React from 'react';
import './Loader.css'; // Import the CSS for styling

const Loader = () => {
  return (
    <div className="loader-containers1">
      <div className="spinner">
        <div className="spinner-segment"></div>
        <div className="spinner-segment"></div>
        <div className="spinner-segment"></div>
        <div className="spinner-segment"></div>
        <div className="spinner-segment"></div>
        <div className="spinner-segment"></div>
        <div className="spinner-segment"></div>
        <div className="spinner-segment"></div>
        <div className="spinner-segment"></div>
        <div className="spinner-segment"></div>
        <div className="spinner-segment"></div>
        <div className="spinner-segment"></div>
      </div>
    </div>
  );
};

export default Loader;
